import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, GitBranchIcon, PaletteIcon, BarChart3Icon } from 'lucide-react';
export function Problems() {
  const problems = [{
    icon: UsersIcon,
    title: 'Scattered Rosters',
    description: 'Player info across Discord, spreadsheets, and DMs. No single source of truth for your competitive lineup.'
  }, {
    icon: GitBranchIcon,
    title: 'Manual Brackets',
    description: 'Tournament organizers still use screenshot brackets and honor systems. Results get lost, disputes arise.'
  }, {
    icon: PaletteIcon,
    title: 'No Team Identity',
    description: 'Clans lack professional branding tools. Custom jersey design costs thousands and takes weeks.'
  }, {
    icon: BarChart3Icon,
    title: 'Zero Analytics',
    description: 'Match data disappears after scrims. No way to track improvement, identify weaknesses, or scout opponents.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      x: -30
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section id="features" className="relative py-24 sm:py-32 overflow-hidden" data-id="element-178">
      <div className="absolute inset-0 bg-gray-950 bg-dot-pattern opacity-50" data-id="element-179" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-181">
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl text-white mb-4" data-id="element-182">
            THE BATTLEFIELD IS <span className="text-red-500" data-id="element-183">BROKEN</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-184">
            Esports teams waste hours on fragmented tools that weren't built for
            competitive gaming.
          </p>
        </motion.div>

        {/* Problem Cards */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-185">
          {problems.map(problem => <motion.div key={problem.title} variants={cardVariants} className="group relative bg-gray-900/60 backdrop-blur-sm border-l-4 border-cyan-500 rounded-r-lg p-6 hover:bg-gray-900/80 transition-colors" data-id="element-186">
              <div className="flex items-start gap-4" data-id="element-187">
                <div className="flex-shrink-0 w-12 h-12 bg-gray-800 border border-gray-700 rounded-lg flex items-center justify-center group-hover:border-cyan-500/50 transition-colors" data-id="element-188">
                  <problem.icon className="w-6 h-6 text-cyan-400" data-id="element-189" />
                </div>
                <div data-id="element-190">
                  <h3 className="font-display font-bold text-xl text-white mb-2 uppercase tracking-wide" data-id="element-191">
                    {problem.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-192">
                    {problem.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}